import {SupportResult, SupportResultRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {COLOR_GRIS} from "../../../../components/layout/colors";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";

export const SupportResultListPage = () => {
	const apiManager = useApiManager();
	const ctrl = apiManager.factory(SupportResultRestControllerApiFactory);

	const listConfig: AppListConfig<SupportResult> = {
		title: "Respuestas de valoración",
		onClick: "/app/admin/compliance/supportresult",
		headers: [
			{title: "Nombre"},
			{title: "Nivel", align: "right", width: 120},
		],
		decorator: (bean: SupportResult) => (
			< >
				<TableCell style={{color: bean.dismissed ? COLOR_GRIS : ""}}>
					{bean.label}
				</TableCell>
				<TableCell align="right" sx={{fontVariantNumeric: "tabular-nums"}}>
					{bean.level}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			return ctrl.pageSupportResult(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};